// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Aileron-UltraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Aileron-UltraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Aileron-UltraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Aileron-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/Aileron-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/Aileron-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/Aileron-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/Aileron-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/Aileron-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/Aileron-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/PlayfairDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/PlayfairDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("fonts/PlayfairDisplay-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("images/gradient.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("images/browse.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("images/profile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("images/discover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("images/messages.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("images/account.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("images/premium.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("images/flintt-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("images/stealth-hide.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("images/discover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("images/profile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("images/premium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("images/gradient.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */

@font-face {
  font-family: 'Aileron-UltraLight';
  font-style: normal;
  font-variant-ligatures: no-common-ligatures;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

@font-face {
  font-family: 'Aileron-Light';
  font-style: normal;
  font-variant-ligatures: no-common-ligatures;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
}

@font-face {
  font-family: 'Aileron-SemiBold';
  font-style: normal;
  font-weight: 500;
  font-variant-ligatures: no-common-ligatures;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2');
}

@font-face {
  font-family: 'PlayfairDisplay-Regular';
  font-style: normal;
  font-weight: 500;
  font-variant-ligatures: no-common-ligatures;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2');
}

/* Text styling */

h1, h2, h3 {
  font-family: "PlayfairDisplay-Regular";
  color: #FBEAD3;
}

p, fieldset {
  color: #fff;
}

p, fieldset, textarea, button {
  font-family: "Aileron-Light";
  font-variant-ligatures: no-common-ligatures;
}

form p {
  font-size: 1em;
}

strong, span, a, li {
  font-family: "Aileron-SemiBold";
  color: #FBEAD3;
  transition: 0.3s; 
}

span {
  font-size: 1rem;
} 

a:hover {
  color: #fff;
  transition: 0.3s;
}

ol, ul, li {
  list-style-type: none;
}

ul {
  padding-left: 0;
}

.primary a {
  text-decoration: none;
}

.tiny-text {
  font-size: 0.7em;
}

footer span {
  font-size: 0.7em;
}

/* Scrollbar */

body {
  scrollbar-width: thin;          /* "auto" or "thin" */
  scrollbar-color: #24252a #fbead3;   /* scroll thumb and track */ 
}

body::-webkit-scrollbar {
  width: 12px;               /* width of the entire scrollbar */
}

body::-webkit-scrollbar-track {
  background: #24252A;        /* color of the tracking area */
}

body::-webkit-scrollbar-thumb {
  background-color: #FBEAD3;    /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
}

/* Layout */

body {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) #24252A;
  background-size: cover;
  margin: 0;
  font-size: 1em;
}

#root {
  width: 100vw;
}

.App {
  width: 100%;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
}

.content {
  margin: 0 auto 50px;
  padding-top: 10vh;
  max-width: 90%;
}

.static {
  max-width: 70%;
}

.aside {
  min-height: 500px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-size: cover;
  background-position: center center;
}

@media screen and (min-width: 968px) {
  .content {
    margin-left: 200px;
  }
}

/* Navbar */

.primary-menu {
    display: none;
  }

.close-button {
  cursor: pointer;
  position: relative;
  top: 10px;
  right: 10px;
}

nav.primary-menu {
  position: fixed;  
  text-align: right;
  width: 200px;
  height: 100vh;
  background: #24252A;
}

.main-navigation {
  height: 100%;
}

.main-navigation, .main-navigation ul {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.main-navigation li a {
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;  
}

.main-navigation .logout-button {
  margin-top: 10px;
}

.nav-profile {
  height: 15px;
  width: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: cover;
}

.nav-discover {
  height: 15px;
  width: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
}

.nav-messages {
  height: 15px;
  width: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-size: cover;
}

.nav-account {
  height: 15px;
  width: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-size: cover;
}

.nav-premium {
  height: 15px;
  width: 15px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: cover;
}



/* Logo */

.logo {
  margin: 20px;
}

.nav-logo, .logo {
  width: 90px;
  height: 50px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat;
  background-size: contain;
  background-position: center center;
}

/* Auth */

.auth .content {
  text-align: center;
}

.log-in-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 20px;
}

/* Form */

.log-in-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.log-in-form input {
  min-width: 200px;
}

input[type=email], input[type=password], input[type=text], input[type=number], textarea, select {
  margin-bottom: 15px;
  border: 1px solid #000;
  padding: 7px 15px;
  background: #FBEAD3;
}

input[type=password] {
  margin-bottom: 20px;  
}

input[type=file] {
  color: #FBEAD3;
}

input[type=submit], .login-button, .logout-button, .signup-button {
  cursor: pointer;
  padding: 7px 15px;
  margin-bottom: 10px;
  border-radius: 30px;
  border: 0;
  background-color: #FBEAD3;
  font-family: "Aileron-SemiBold";
}

input[type=submit], .login-button {
  min-width: 180px;
}

.signup-button {
  margin: 30px auto;
  width: 150px;
  text-align: center;
}

.login-button a, .signup-button a {
  color: #000;
  text-decoration: none;
}

input[type=submit]:hover, button:hover, .signup-button:hover {
  filter: sepia(1);
  transition: 0.3s;
}

input[type=email]:focus {
  outline:none;
}

input[type=checkbox] {
  color: #000;
}

fieldset {
  border: 0;
  padding: 0;
}

fieldset p {
  padding-top: 10px;
}

.details-group {
  padding: 0 0 35px;
}

.details-group input {
  margin: 10px 0;
}

.details-group p {
  margin: 0
}

input[type=checkbox], input[type=radio] {
  margin-right: 5px;
}

[class^="details-"] select label, [class^="details-"] fieldset label, .profile-group select {
  min-width: 190px;
  text-transform: capitalize;
  padding-right: 10px;
}

[class^="details-"] label {
  padding-right: 5px;
}

.details-location {
  margin-bottom: 10px;
  text-transform: lowercase;
}

.almost-done {
  margin: 0 0 25px 0;
}

.details-group input[type=text]#bio {
  width: 93%;
  min-height: 100px;
}

.submit-button {
  text-align: center;
}

/* Register */

.register {
  align-items: flex-start;
}

.register textarea {
  width: 90%;
  min-height: 100px;
  margin-top: 5px;
}

.error-message {
  color: red;
  font-size: 0.9rem;
  margin: 0.25rem 0;
}


/* About */

.features div {
  display: flex;
  gap: 10px;
  padding-bottom: 10px;
}

.features div div {
  flex-direction: column;
}

.features div div p {
  margin: 0;
}

div.stealth-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
}

.browser-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 15px;
  width: 15px;
}

.community-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
}

.premium-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: contain;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
}

/* Footer */

footer {
  width: 100%;
  text-align: center;
  background: #24252A;
  display: flex;
  flex-direction: column;
}

/* Media queries */

@media screen and (max-width: 768px) {
  .footer-menu a {
    padding-right: 5px;
  }
  footer span {
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

/* Tablet */

@media screen and (min-width: 768px) {

  header {
    position: fixed;
  }

  .logo img {
    width: 70px;
    height: 30px;
  }

  .aside {
    min-height: 100%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) #24252A;
    background-size: cover;
    background-position: center center;
  }
  
}

/* Desktop */

@media screen and (min-width: 1028px) {

  body {
    min-height: 100vh;
    display: flex;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) #000;
    background-attachment: fixed;
  }

  .content {
    padding-top: 20vh;
    padding-bottom: 10vh;
  }
  
  .content.has-aside {
    width: 37.5%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .aside {
    height: 100vh;
    width: 40%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: -1;
  }

  .register input[type=text], .register input[type=email], .register input[type=password] {
    min-width: 300px;
  }

  .footer {
    width: 60%;
  }

  footer {
    position: fixed;
    bottom: 0;
    grid-template-columns: 1fr 1fr 1fr;
    display: grid;
    padding-bottom: 5px;
  }

  footer span {
    margin-top: 3px;
  }

  footer span:first-of-type {
    padding-left: 10px;
    text-align: left;
  }

  footer span:last-of-type {
    padding-right: 10px;
    text-align: right;
  }

  .footer-menu a {
    padding-right: 10px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;EACE,iCAAiC;EACjC,kBAAkB;EAClB,2CAA2C;EAC3C;;;2DAGuD;AACzD;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,2CAA2C;EAC3C;;;;2DAIkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C;;;2DAGqD;AACvD;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C;;;4DAG4D;AAC9D;;AAEA,iBAAiB;;AAEjB;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;;AAEd;EACE,qBAAqB,WAAW,qBAAqB;EACrD,gCAAgC,IAAI,2BAA2B;AACjE;;AAEA;EACE,WAAW,gBAAgB,kCAAkC;AAC/D;;AAEA;EACE,mBAAmB,SAAS,+BAA+B;AAC7D;;AAEA;EACE,yBAAyB,KAAK,8BAA8B;EAC5D,mBAAmB,QAAQ,kCAAkC;AAC/D;;AAEA,WAAW;;AAEX;EACE,4DAA+C;EAC/C,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,oDAAqC;EACrC,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,WAAW;;AAEX;IACI,aAAa;EACf;;AAEF;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAqC;EACrC,sBAAsB;AACxB;;;;AAIA,SAAS;;AAET;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8DAAmD;EACnD,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,SAAS;;AAET;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;;AAEb;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;;AAGA,UAAU;;AAEV;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oDAA0C;EAC1C,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oDAAsC;EACtC,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oDAAqC;EACrC,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oDAAqC;EACrC,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;;AAElB;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,WAAW;;AAEX;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,4DAA6C;IAC7C,sBAAsB;IACtB,kCAAkC;EACpC;;AAEF;;AAEA,YAAY;;AAEZ;;EAEE;IACE,iBAAiB;IACjB,aAAa;IACb,yDAA2C;IAC3C,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;;EAEA;IACE,aAAa;IACb,UAAU;IACV,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,kCAAkC;IAClC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;AAEF","sourcesContent":["/* Fonts */\n\n@font-face {\n  font-family: 'Aileron-UltraLight';\n  font-style: normal;\n  font-variant-ligatures: no-common-ligatures;\n  src:\n    url('fonts/Aileron-UltraLight.ttf') format('truetype'),\n    url('fonts/Aileron-UltraLight.woff') format('woff'),\n    url('fonts/Aileron-UltraLight.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Aileron-Light';\n  font-style: normal;\n  font-variant-ligatures: no-common-ligatures;\n  src:\n    url('fonts/Aileron-Light.otf') format('opentype'),\n    url('fonts/Aileron-Light.ttf') format('truetype'),\n    url('fonts/Aileron-Light.woff') format('woff'),\n    url('fonts/Aileron-Light.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'Aileron-SemiBold';\n  font-style: normal;\n  font-weight: 500;\n  font-variant-ligatures: no-common-ligatures;\n  src:\n    url('fonts/Aileron-SemiBold.ttf') format('truetype'),\n    url('fonts/Aileron-SemiBold.woff') format('woff'),\n    url('fonts/Aileron-SemiBold.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: 'PlayfairDisplay-Regular';\n  font-style: normal;\n  font-weight: 500;\n  font-variant-ligatures: no-common-ligatures;\n  src:\n    url('fonts/PlayfairDisplay-Regular.ttf') format('truetype'),\n    url('fonts/PlayfairDisplay-Regular.woff') format('woff'),\n    url('fonts/PlayfairDisplay-Regular.woff2') format('woff2');\n}\n\n/* Text styling */\n\nh1, h2, h3 {\n  font-family: \"PlayfairDisplay-Regular\";\n  color: #FBEAD3;\n}\n\np, fieldset {\n  color: #fff;\n}\n\np, fieldset, textarea, button {\n  font-family: \"Aileron-Light\";\n  font-variant-ligatures: no-common-ligatures;\n}\n\nform p {\n  font-size: 1em;\n}\n\nstrong, span, a, li {\n  font-family: \"Aileron-SemiBold\";\n  color: #FBEAD3;\n  transition: 0.3s; \n}\n\nspan {\n  font-size: 1rem;\n} \n\na:hover {\n  color: #fff;\n  transition: 0.3s;\n}\n\nol, ul, li {\n  list-style-type: none;\n}\n\nul {\n  padding-left: 0;\n}\n\n.primary a {\n  text-decoration: none;\n}\n\n.tiny-text {\n  font-size: 0.7em;\n}\n\nfooter span {\n  font-size: 0.7em;\n}\n\n/* Scrollbar */\n\nbody {\n  scrollbar-width: thin;          /* \"auto\" or \"thin\" */\n  scrollbar-color: #24252a #fbead3;   /* scroll thumb and track */ \n}\n\nbody::-webkit-scrollbar {\n  width: 12px;               /* width of the entire scrollbar */\n}\n\nbody::-webkit-scrollbar-track {\n  background: #24252A;        /* color of the tracking area */\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: #FBEAD3;    /* color of the scroll thumb */\n  border-radius: 20px;       /* roundness of the scroll thumb */\n}\n\n/* Layout */\n\nbody {\n  background: url('images/gradient.webp') #24252A;\n  background-size: cover;\n  margin: 0;\n  font-size: 1em;\n}\n\n#root {\n  width: 100vw;\n}\n\n.App {\n  width: 100%;\n}\n\n.main {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n}\n\n.content {\n  margin: 0 auto 50px;\n  padding-top: 10vh;\n  max-width: 90%;\n}\n\n.static {\n  max-width: 70%;\n}\n\n.aside {\n  min-height: 500px;\n  width: 100%;\n  background: url('images/browse.webp');\n  background-size: cover;\n  background-position: center center;\n}\n\n@media screen and (min-width: 968px) {\n  .content {\n    margin-left: 200px;\n  }\n}\n\n/* Navbar */\n\n.primary-menu {\n    display: none;\n  }\n\n.close-button {\n  cursor: pointer;\n  position: relative;\n  top: 10px;\n  right: 10px;\n}\n\nnav.primary-menu {\n  position: fixed;  \n  text-align: right;\n  width: 200px;\n  height: 100vh;\n  background: #24252A;\n}\n\n.main-navigation {\n  height: 100%;\n}\n\n.main-navigation, .main-navigation ul {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\n\n.main-navigation li a {\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;  \n}\n\n.main-navigation .logout-button {\n  margin-top: 10px;\n}\n\n.nav-profile {\n  height: 15px;\n  width: 15px;\n  background: url('images/profile.png');\n  background-size: cover;\n}\n\n.nav-discover {\n  height: 15px;\n  width: 15px;\n  background: url('images/discover.png');\n  background-size: cover;\n}\n\n.nav-messages {\n  height: 15px;\n  width: 15px;\n  background: url('images/messages.png');\n  background-size: cover;\n}\n\n.nav-account {\n  height: 15px;\n  width: 15px;\n  background: url('images/account.png');\n  background-size: cover;\n}\n\n.nav-premium {\n  height: 15px;\n  width: 15px;\n  background: url('images/premium.png');\n  background-size: cover;\n}\n\n\n\n/* Logo */\n\n.logo {\n  margin: 20px;\n}\n\n.nav-logo, .logo {\n  width: 90px;\n  height: 50px;\n  background: url('images/flintt-logo.png') no-repeat;\n  background-size: contain;\n  background-position: center center;\n}\n\n/* Auth */\n\n.auth .content {\n  text-align: center;\n}\n\n.log-in-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n\n/* Form */\n\n.log-in-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.log-in-form input {\n  min-width: 200px;\n}\n\ninput[type=email], input[type=password], input[type=text], input[type=number], textarea, select {\n  margin-bottom: 15px;\n  border: 1px solid #000;\n  padding: 7px 15px;\n  background: #FBEAD3;\n}\n\ninput[type=password] {\n  margin-bottom: 20px;  \n}\n\ninput[type=file] {\n  color: #FBEAD3;\n}\n\ninput[type=submit], .login-button, .logout-button, .signup-button {\n  cursor: pointer;\n  padding: 7px 15px;\n  margin-bottom: 10px;\n  border-radius: 30px;\n  border: 0;\n  background-color: #FBEAD3;\n  font-family: \"Aileron-SemiBold\";\n}\n\ninput[type=submit], .login-button {\n  min-width: 180px;\n}\n\n.signup-button {\n  margin: 30px auto;\n  width: 150px;\n  text-align: center;\n}\n\n.login-button a, .signup-button a {\n  color: #000;\n  text-decoration: none;\n}\n\ninput[type=submit]:hover, button:hover, .signup-button:hover {\n  filter: sepia(1);\n  transition: 0.3s;\n}\n\ninput[type=email]:focus {\n  outline:none;\n}\n\ninput[type=checkbox] {\n  color: #000;\n}\n\nfieldset {\n  border: 0;\n  padding: 0;\n}\n\nfieldset p {\n  padding-top: 10px;\n}\n\n.details-group {\n  padding: 0 0 35px;\n}\n\n.details-group input {\n  margin: 10px 0;\n}\n\n.details-group p {\n  margin: 0\n}\n\ninput[type=checkbox], input[type=radio] {\n  margin-right: 5px;\n}\n\n[class^=\"details-\"] select label, [class^=\"details-\"] fieldset label, .profile-group select {\n  min-width: 190px;\n  text-transform: capitalize;\n  padding-right: 10px;\n}\n\n[class^=\"details-\"] label {\n  padding-right: 5px;\n}\n\n.details-location {\n  margin-bottom: 10px;\n  text-transform: lowercase;\n}\n\n.almost-done {\n  margin: 0 0 25px 0;\n}\n\n.details-group input[type=text]#bio {\n  width: 93%;\n  min-height: 100px;\n}\n\n.submit-button {\n  text-align: center;\n}\n\n/* Register */\n\n.register {\n  align-items: flex-start;\n}\n\n.register textarea {\n  width: 90%;\n  min-height: 100px;\n  margin-top: 5px;\n}\n\n.error-message {\n  color: red;\n  font-size: 0.9rem;\n  margin: 0.25rem 0;\n}\n\n\n/* About */\n\n.features div {\n  display: flex;\n  gap: 10px;\n  padding-bottom: 10px;\n}\n\n.features div div {\n  flex-direction: column;\n}\n\n.features div div p {\n  margin: 0;\n}\n\ndiv.stealth-icon {\n  background: url('images/stealth-hide.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 20px;\n  width: 20px;\n}\n\n.browser-icon {\n  background: url('images/discover.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 15px;\n  width: 15px;\n}\n\n.community-icon {\n  background: url('images/profile.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 20px;\n  width: 20px;\n}\n\n.premium-icon {\n  background: url('images/premium.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  height: 20px;\n  width: 20px;\n}\n\n/* Footer */\n\nfooter {\n  width: 100%;\n  text-align: center;\n  background: #24252A;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Media queries */\n\n@media screen and (max-width: 768px) {\n  .footer-menu a {\n    padding-right: 5px;\n  }\n  footer span {\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n}\n\n/* Tablet */\n\n@media screen and (min-width: 768px) {\n\n  header {\n    position: fixed;\n  }\n\n  .logo img {\n    width: 70px;\n    height: 30px;\n  }\n\n  .aside {\n    min-height: 100%;\n    background: url('images/browse.webp') #24252A;\n    background-size: cover;\n    background-position: center center;\n  }\n  \n}\n\n/* Desktop */\n\n@media screen and (min-width: 1028px) {\n\n  body {\n    min-height: 100vh;\n    display: flex;\n    background: url('images/gradient.png') #000;\n    background-attachment: fixed;\n  }\n\n  .content {\n    padding-top: 20vh;\n    padding-bottom: 10vh;\n  }\n  \n  .content.has-aside {\n    width: 37.5%;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .aside {\n    height: 100vh;\n    width: 40%;\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: -1;\n  }\n\n  .register input[type=text], .register input[type=email], .register input[type=password] {\n    min-width: 300px;\n  }\n\n  .footer {\n    width: 60%;\n  }\n\n  footer {\n    position: fixed;\n    bottom: 0;\n    grid-template-columns: 1fr 1fr 1fr;\n    display: grid;\n    padding-bottom: 5px;\n  }\n\n  footer span {\n    margin-top: 3px;\n  }\n\n  footer span:first-of-type {\n    padding-left: 10px;\n    text-align: left;\n  }\n\n  footer span:last-of-type {\n    padding-right: 10px;\n    text-align: right;\n  }\n\n  .footer-menu a {\n    padding-right: 10px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
